import React, { useEffect } from "react";
import { connect } from "react-redux";

import { authenticationAction } from "_actions";
import Emitter from "_actions/emitter";
import { checkTokenExpires } from "_services/httpOperations";

// User has switched away from the tab (AKA tab is hidden)
const onBlur = () => {
  //console.log("Tab is blurred");
};

export const checkCustomTokenExpires = async () => {
  try {
    await checkTokenExpires(false)
      .then((data) => {
        // Token başarıyla kontrol edildi veya yenilendi
        // false dönerse token yok veya geçersiz, bu normal olabilir
        // true dönerse token geçerli veya yenilendi
        if (data === false) {
          // Token yok veya geçersiz - bu normal bir durum olabilir, reload yapma
          return;
        }
        // Token başarıyla kontrol edildi veya yenilendi
      })
      .catch((err) => {
        // Sadece gerçek token yenileme hatalarında işlem yap
        // OAuth2Service.REFRESH_TOKEN başarısız olduğunda buraya gelir
        console.error("Token yenileme hatası:", err);
        // Token yenileme başarısız olduğunda logout yap
        Emitter.emit("LOGOUT", true);
      });
  } catch (error) {
    // Beklenmeyen hatalar için sadece log, reload yapma
    console.error("Token kontrolü beklenmeyen hatası:", error);
  }
};
const onFocus = () => {
  checkCustomTokenExpires();
};
const WindowFocusHandler = () => {
  useEffect(() => {
    window.addEventListener("focus", onFocus);
    window.addEventListener("blur", onBlur);
    // Calls onFocus when the window first loads
    onFocus();
    // Specify how to clean up after this effect:
    return () => {
      window.removeEventListener("focus", onFocus);
      window.removeEventListener("blur", onBlur);
    };
  }, []);

  return <></>;
};

const mapStateToProps = (state, props) => {
  const { authentication } = state;
  const { user, loggedIn } = authentication;

  return {
    user,
    loggedIn,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    UpdateUser: (user) => dispatch(authenticationAction.UpdateUser(user)),
    LoginSuccess: (user) => dispatch(authenticationAction.LoginSuccess(user)),
    LoginFailure: () => dispatch(authenticationAction.LoginFailure()),
    logout: () => dispatch(authenticationAction.logout()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(WindowFocusHandler);
